import { useMemo } from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { getContactDashboard } from "../../action";
import { RootState } from "../../../../../store";
import Speed from "../../../../../assets/img/icons/Speed.svg";
import TableSort from "modules/Common/Components/TableSort";
import { addCommaToNumber, getQueryContactId } from "utils";
import ContactListLoader from "../../ContactListLoader";
import { ISubscribedCampaignItem } from "modules/Analytics/interfaces";
import { Tooltip } from "antd";

const DEFAULT_PAGE_LIMIT = 20;

const CampaignsListing = () => {
  //Redux states
  const campaigns: Array<ISubscribedCampaignItem> = useSelector(
    (state: RootState) => state.contactInnerDetails.dashboard.subscribed_campaigns
  );
  const totalCampaigns = useSelector(
    (state: RootState) => state.contactInnerDetails.dashboard.total_subscribed_campaigns
  );
  const campaignsLoading = useSelector((state: RootState) => state.contactInnerDetails.dashboard.campaingsLoading);
  const loading = useSelector((state: RootState) => state.contactInnerDetails.dashboard.dashboardLoading);
  const page = useSelector((state: RootState) => state.contactInnerDetails.dashboard.campaignsPage);

  let columnsData = useMemo(
    () => [
      {
        id: "main",
        hideHeader: true,
        disableSortBy: true,
        columns: [
          {
            id: "name_or_sent",
            Header: "Name/ Sent",
            accessor: "name",
            disableSortBy: true,
            Cell: (props: any) => {
              let item = props.row.original;
              return (
                <div>
                  <div className="campaign_name">{item?.name}</div>
                  <div className="email_name">
                    <span className="label">Recent Email: </span>
                    <span className="name">
                      <Tooltip placement="top" title={item?.recent_email}>
                        {item?.recent_email}
                      </Tooltip>
                    </span>
                  </div>
                  <div className="campaign_sent">
                    <span className="label">Sent at: </span>
                    <span className="date">
                      <Tooltip placement="top" title={item?.sent_at}>
                        {item?.sent_at}
                      </Tooltip>
                    </span>
                  </div>
                </div>
              );
            },
          },
          {
            id: "sent",
            Header: "Sent (Delivered % )",
            accessor: "sent",
            disableSortBy: true,
            Cell: (props: any) => {
              let item = props.row.original;
              return (
                <div className="total_sent">
                  {addCommaToNumber((item.sent ?? 0).toString() ?? "")} ({item.sent_percentage}%)
                </div>
              );
            },
          },
          {
            id: "opens",
            Header: "Opens",
            accessor: "opens",
            disableSortBy: true,
            Cell: (props: any) => {
              let item = props.row.original;
              return addCommaToNumber((item.opens ?? 0).toString() ?? "");
            },
          },
          {
            id: "clicks",
            Header: "Clicks",
            accessor: "clicks",
            disableSortBy: true,
            Cell: (props: any) => {
              let item = props.row.original;
              return (
                <div className="total_clicks">
                  {addCommaToNumber((item.clicks ?? 0).toString() ?? "")} ({item.click_percentage}%)
                </div>
              );
            },
          },
          {
            id: "score",
            Header: "Score",
            accessor: "score",
            disableSortBy: true,
            Cell: (props: any) => {
              let item = props.row.original;
              return (
                <div className="engagement">
                  <img src={Speed} />
                  &nbsp;
                  {addCommaToNumber((item.score ?? 0).toString() ?? "")}
                </div>
              );
            },
          },
        ],
      },
    ],
    []
  );

  const getPagination = () => {
    return {
      limit: DEFAULT_PAGE_LIMIT,
      contact_id: getQueryContactId(),
      offset: totalCampaigns ? campaigns?.length : 0,
    };
  };

  return (
    <>
      <Wrapper>
        {campaigns !== undefined && (
          // <InfiniteLoader
          //   dataLength={campaigns?.length}
          //   next={() => getContactDashboard(getPagination(), true)}
          //   hasMore={true}
          //   loader={<ContactListLoader loading={campaignsLoading} />}
          // >
          <>
            <TableSort
              columns={columnsData}
              data={campaigns}
              module={"campaigns"}
              next={() => getContactDashboard(getPagination(), true)}
              hasMore={true}
              loader={<ContactListLoader loading={campaignsLoading} />}
              wrapperClassName="campaigns-table-wrapper table-unique-scroll"
              loading={campaignsLoading}
              noScrollTarget={false}
            />
            {!campaignsLoading && campaigns?.length === 0 ? <div className="no-data">No Data Found!</div> : null}
            {/* {<ContactListLoader loading={campaignsLoading} />}
          </InfiniteLoader> */}
          </>
        )}
      </Wrapper>
    </>
  );
};

export default CampaignsListing;

const Wrapper = styled.div`
  overflow: hidden;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: transparent;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    /* border-radius: 7px;
    padding: 10px 12px; */
    min-height: 83px;
  }

  .table-unique-scroll {
    &.campaigns-table-wrapper {
      #scrollableDiv {
       max-height: 400px !important;
       overflow: auto !important;
       @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        max-height: 290px !important;
       }
        .infinite-scroll-component  {
          min-height: unset;
          max-height: unset !important;
          height: auto !important;
          overflow: hidden!important;
        }
      }
    }
  }
  #scrollableDiv {
    .infinite-scroll-component {
      min-height:unset;
    }
  }
  .infinite-scroll-component {
    max-height: 430px;
    overflow: auto !important;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      max-height: 320px;
    }
    &::-webkit-scrollbar {
      /* display: none; */
    }
    &::-webkit-scrollbar {
      width: 5px;
      height: 5px;
      border-radius: 5px;
    }
    /* Track */
    &::-webkit-scrollbar-track {
      background: transparent;
      margin-top: 0;
      margin-bottom: 5px;
      margin-left: 5px;
    }
    /* Handle */
    &::-webkit-scrollbar-thumb {
      background: #001760;
    }
    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
  }
  .no-data {
    width: 100%;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: "robotomedium";
    color: #67696a;
    font-size: 1rem;
    margin-bottom: 30px;
    /* box-shadow: 6px 30px 73px -10px grey; */
    border-radius: 5px;
  }

  .profile-campaign-list {
    width: 100%;
    max-height: 430px;
    overflow: auto;
    scrollbar-width: thin;
    scrollbar-color: #001760 #efefef;
    position: relative;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      max-height: 317px;
    }
    ::-webkit-scrollbar {
      width: 5px;
      height: 5px;
      border-radius: 2px;
    }
    /* Track */
    ::-webkit-scrollbar-track {
      background: #efefef;
      margin-top: 10px;
      margin-bottom: 15px;
    }
    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: #001760;
    }
    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
  }
  .campaigns-table-wrapper {
    max-height: 425px !important;
    padding-bottom: 0 !important;
    height: auto;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      max-height: 315px !important;
    }
    #scrollableDiv{
      max-height: 460px !important;
    }

    .infinite-scroll-component {
      max-height: 400px !important;
      @media (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        max-height: 290px !important;
      }
    }
  }

  table {
    width: 100%;
    thead {
      border-bottom: 1px solid #dddddd;
      background-color: #f8f7f5;
      position: sticky;
      top: 0;
      left: 0;
      z-index: 9;
      tr {
        padding-right: 15px;
        padding-left: 15px;
        th {
          color: #5e7079;
          font-weight: 700;
          font-size: 18px;
          font-family: "Roboto", sans-serif;
        }
      }
    }
    tbody {
      width: 100%;
      display: block;
      box-sizing: border-box;
      overflow-y: auto;
      /* height: calc(100vh - 340px); */
      /* padding-bottom: 90px; */
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        /* height: calc(100vh - 300px); */
      }
      scrollbar-width: thin;
      scrollbar-color: #001760 #efefef;
      &::-webkit-scrollbar {
        width: 5px;
        height: 5px;
        border-radius: 5px;
      }
      /* Track */
      &::-webkit-scrollbar-track {
        background: #fff;
        margin-top: 0;
        margin-bottom: 10px;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          margin-top: 0;
        }
      }
      /* Handle */
      &::-webkit-scrollbar-thumb {
        background: #001760;
      }
      /* Handle on hover */
      /* &::-webkit-scrollbar-thumb:hover {
        background: #efefef;
      } */
      > div {
        overflow: hidden;
      }
      .infinite-scroll-component__outerdiv {
        .infinite-scroll-component {
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            max-height: 290px;
          }
        }
      }
      tr {
        background-color: #ffffff;
        box-shadow: 0px 0px 17px -2px rgba(0, 0, 0, 0.08);
        width: 100%;
        border-radius: 8px;
        transition-duration: 0.2s;
        position: relative;
        margin: 4px 0;
        padding: 16px 15px 10px 15px;
        @media all and (max-width: 1439px), (max-height: 730px), (-webkit-device-pixel-ratio: 1.25) {
          padding-right: 0px;
        }
      }
    }
    thead {
      tr {
        th {
          span {
            width: 15px;
            .sort_asc {
              width: 10px;
              height: 8px;
              margin-top: -15px;
              margin-left: 5px;
              float: left;
              @media all and (max-width: 1439px), (-webkit-device-pixel-ratio: 1.25) {
                margin-top: -13px;
              }
              img {
                transform: rotate(180deg);
              }
            }
            .sort_desc {
              width: 10px;
              height: 8px;
              float: left;
              margin-left: 5px;
              margin-top: 5px;
              img {
                float: left;
              }
            }
          }
        }
      }
      tr:nth-child(2) {
        th {
          font-size: 16px;
          color: #5e7079;
          font-weight: 500;
          font-family: "Roboto", sans-serif;
          white-space: nowrap;
          @media all and (max-width: 1439px), (-webkit-device-pixel-ratio: 1.25) {
            font-size: 14px;
          }
        }
      }
    }
    thead,
    tbody {
      width: 100%;
      display: block;
      float: left;
      tr {
        width: 100%;
        display: block;
        float: left;
        td {
          min-height: 70px;
          font-family: "Roboto", sans-serif;
          font-weight: 500;
          font-size: 20px;
          @media all and (max-width: 1439px), (-webkit-device-pixel-ratio: 1.25) {
            font-size: 14px;
          }
        }
        th,
        td {
          display: block;
          float: left;
          &:nth-child(1) {
            width: calc(100% - 510px);
            text-align: left;
            @media all and (max-width: 1439px) {
              width: calc(100% - 510px);
              //Safari (7.1+)
              _::-webkit-full-page-media,
              _:future,
              :root .safari_only {
                width: calc(100% - 510px);
              }
              //Safari (from 6.1 to 10)
              @media screen and (min-color-index: 0) and(-webkit-min-device-pixel-ratio:0) {
                @media {
                  width: calc(100% - 510px);
                }
              }
              //Safari (10.1+)
              @media not all and (min-resolution: 0.001dpcm) {
                @media {
                  width: calc(100% - 510px);
                }
              }
            }
            > div {
              display: flex;
              width: 100%;
              flex-direction: column;
              align-items: start;
              align-content: space-evenly;
              justify-content: center;
              min-height: 65px;
              .campaign_name {
                overflow: hidden;
                text-overflow: ellipsis;
                /* white-space: nowrap;
                word-break: keep-all; */
                display: block;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
                word-break: break-word;
                font-size: 20px;
                max-width: 100%;
                line-height: 22px;
                @media all and (max-width: 1439px), (-webkit-device-pixel-ratio: 1.25) {
                  font-size: 14px;
                  line-height: 16px;
                }
              }
              .email_name{
                font-family: 'Roboto';
                font-style: normal;
                font-size: 12px;
                line-height: 14px;
                color: #000000;

                max-width: 200px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                .label{
                  font-weight: 400;
                }
                .name{
                 font-weight: 500;
                }
                @media all and (max-width: 1439px), (-webkit-device-pixel-ratio: 1.25) {
                  font-size: 10px;
                  line-height: 12px;
                }
              }
              .campaign_sent {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                word-break: keep-all;
                display: block;
                font-size: 12px;
                .label{
                  font-weight: 400;
                }
                .date{
                 font-weight: 500;
                }
                @media all and (max-width: 1439px), (-webkit-device-pixel-ratio: 1.25) {
                  font-size: 10px;
                }
              }
            }
          }
          &:nth-child(2) {
            width: 150px;
            text-align: left;
            display: inline-flex;
            align-items: center;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            word-break: keep-all;
            justify-content: center;
            @media all and (max-width: 1439px) {
              width: 120px;
              //Safari (7.1+)
              _::-webkit-full-page-media,
              _:future,
              :root .safari_only {
                width: 120px;
              }
              //Safari (from 6.1 to 10)
              @media screen and (min-color-index: 0) and(-webkit-min-device-pixel-ratio:0) {
                @media {
                  width: 120px;
                }
              }
              //Safari (10.1+)
              @media not all and (min-resolution: 0.001dpcm) {
                @media {
                  width: 120px;
                }
              }
            }
            .total_sent {
              white-space: nowrap;
              max-width: 100%;
            }
          }
          &:nth-child(3) {
            width: 120px;
            text-align: left;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            @media all and (max-width: 1439px) {
              width: 100px;
              //Safari (7.1+)
              _::-webkit-full-page-media,
              _:future,
              :root .safari_only {
                width: 100px;
              }
              //Safari (from 6.1 to 10)
              @media screen and (min-color-index: 0) and(-webkit-min-device-pixel-ratio:0) {
                @media {
                  width: 100px;
                }
              }
              //Safari (10.1+)
              @media not all and (min-resolution: 0.001dpcm) {
                @media {
                  width: 100px;
                }
              }
            }
          }
          &:nth-child(4) {
            width: 120px;
            text-align: center;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            @media all and (max-width: 1439px) {
              width: 140px;
              //Safari (7.1+)
              _::-webkit-full-page-media,
              _:future,
              :root .safari_only {
                width: 140px;
              }
              //Safari (from 6.1 to 10)
              @media screen and (min-color-index: 0) and(-webkit-min-device-pixel-ratio:0) {
                @media {
                  width: 140px;
                }
              }
              //Safari (10.1+)
              @media not all and (min-resolution: 0.001dpcm) {
                @media {
                  width: 140px;
                }
              }
            }
            .total_clicks {
              white-space: nowrap;
              max-width: 100%;
            }
          }
          &:nth-child(5) {
            width: 120px;
            text-align: center;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            @media all and (max-width: 1439px) {
              width: 140px;
              //Safari (7.1+)
              _::-webkit-full-page-media,
              _:future,
              :root .safari_only {
                width: 140px;
              }
              //Safari (from 6.1 to 10)
              @media screen and (min-color-index: 0) and(-webkit-min-device-pixel-ratio:0) {
                @media {
                  width: 140px;
                }
              }
              //Safari (10.1+)
              @media not all and (min-resolution: 0.001dpcm) {
                @media {
                  width: 140px;
                }
              }
            }
          }
        }
      }
    }
  }
  .engagement {
    border-radius: 12px;
    background-color: #1971eb;
    color: #ffffff;
    font-size: 16px;
    font-family: "robotomedium";
    font-weight: 500;
    padding: 0px 10px;
    display: inline;
    float: right;
    white-space: nowrap;
  }
  .blog-image {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .blog-image {
    .img1 {
      height: 70px;
      width: 52px;
      border-radius: 6px 0px 0px 6px;
      margin-right: 2px;
      @media all and (max-width: 1439px), (max-height: 730px), (-webkit-device-pixel-ratio: 1.25) {
        border-radius: 4px 0px 0px 4px;
        height: 50px;
        width: 36px;
      }
    }
    .img-bg {
      background-position: center center;
      background-size: cover;
      background-repeat: no-repeat;
    }
    .right-images {
      .overlayed-image {
        position: absolute;
        left: 9%;
        top: 22%;
      }
      .img-bg {
        background-position: center center;
        background-size: cover;
        background-repeat: no-repeat;
      }
      display: flex;
      flex-direction: column;
      .img2 {
        height: 34px;
        width: 39px;
        border-radius: 0px 6px 0px 0px;
        margin-bottom: 1px;
        @media all and (max-width: 1439px), (max-height: 730px), (-webkit-device-pixel-ratio: 1.25) {
          border-radius: 0px 4px 0px 0px;
          height: 25px;
          width: 28px;
        }
      }
      .img3 {
        height: 34px;
        width: 39px;
        border-radius: 0px 0px 6px 0px;
        @media all and (max-width: 1439px), (max-height: 730px), (-webkit-device-pixel-ratio: 1.25) {
          border-radius: 0px 0px 4px 0px;
          height: 23px;
          width: 28px;
        }
      }
    }
  }
  .disabled {
    pointer-events: none !important;
    background-color: rgba(225, 225, 225, 0.7) !important;
    cursor: no-drop;
  }
  .preview {
    position: relative;
    max-width: 55px;
    -ms-flex-negative: 1 !important;
    flex-shrink: 1 !important;
    img {
      border-radius: 100%;
      box-shadow: ${(props) => (props.color ? `0px 0px 0px 2px ${props.color}` : "")};
      max-width: 100%;
      height: 55px;
      width: 55px;
      min-width: 55px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        height: 40px;
        width: 40px;
        min-width: 40px;
      }
    }
  }
  .details {
    padding-left: 15px;
    .name,
    .company,
    .designation,
    .recipient-count {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-bottom: 0px;
      -webkit-box-align: start;
      width: 100%;
      word-break: break-word;
    }
    .name {
      color: #000000;
      font-size: 20px;
      font-weight: 400;
      line-height: 22px;
      font-family: "Roboto Slab", serif;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        line-height: 15px;
        font-size: 13px;
      }
    }
    .list-name {
      color: #000000;
      font-size: 20px;
      font-weight: 400;
      line-height: 22px;
      font-family: "Roboto Slab", serif;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-word;

      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        line-height: 14px;
        font-size: 13px;
      }
    }
    .company {
      -webkit-line-clamp: 1;
      font-family: "Roboto", sans-serif;
      font-weight: 500;
      font-size: 14px;
      line-height: 16px;
      color: #424b50;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        line-height: 18px;
        font-size: 9px;
      }
    }
    .designation {
      -webkit-line-clamp: 1;
      font-family: "Roboto", sans-serif;
      font-weight: 500;
      line-height: 16px;
      font-size: 14px;
      color: #27ce0a;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        line-height: 18px;
        font-size: 9px;
      }
    }
    .recipient-count {
      -webkit-line-clamp: 1;
      font-family: "Roboto", sans-serif;
      font-weight: 500;
      line-height: 16px;
      font-size: 14px;
      color: #27ce0a;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        line-height: 18px;
        font-size: 9px;
      }
    }
  }
  .actions {
    -ms-flex-negative: 1;
    flex-shrink: 1;
    align-self: center;
    margin-left: auto;
    min-width: 106px;
    ul {
      list-style: none;
      margin: 0;
      padding: 0;
      display: flex;
      width: 100%;
      li {
        float: left;
        display: inline-block;
        padding: 0px;
        &.clicks {
          padding-right: 10px;
          .container-span {
            font-family: "Roboto", sans-serif;
            color: #fff;
            font-size: 16px;
            font-weight: 500;
            background-color: #1971eb;
            border-radius: 12px;
            padding: 0px 10px;
            display: inline-flex;
            width: 80px;
            height: 22px;
            justify-content: center;
            align-items: center;
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
              font-size: 11px;
              width: 70px;
            }
            svg {
              vertical-align: baseline;
              margin-right: 5px;
            }
          }
        }
        &.card-popover {
          a {
            padding: 0 5px;
            svg {
              width: 5px;
              max-height: none;
              @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
                width: 3px;
              }
            }
          }
        }
      }
    }
  }
`;
